import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=7b2a1b6c&scoped=true&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"
import style0 from "./Item.vue?vue&type=style&index=0&id=7b2a1b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a1b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2a1b6c')) {
      api.createRecord('7b2a1b6c', component.options)
    } else {
      api.reload('7b2a1b6c', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=7b2a1b6c&scoped=true&", function () {
      api.rerender('7b2a1b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/Location/Item.vue"
export default component.exports